import { AxiosInstance } from 'axios';

import {
  ComponentsAPIApiFactory,
  FeaturesAPIApiFactory,
} from '@cast/openapi-cluster-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const ClusterManagementApiAdapter = (client: AxiosInstance) => {
  const componentsGeneratedApi = ComponentsAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const featuresGeneratedApi = FeaturesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  return {
    getClusterComponents:
      componentsGeneratedApi.componentsAPIViewClusterComponents,
    getClustersComponents:
      componentsGeneratedApi.componentsAPIViewClustersComponents,
    getComponent: componentsGeneratedApi.componentsAPIViewComponent,
    getComponents: componentsGeneratedApi.componentsAPIViewComponents,
    getComponentsInstallOperator:
      componentsGeneratedApi.componentsAPIInstallOperator,
    runComponentAction: componentsGeneratedApi.componentsAPIRunComponentAction,
    getComponentStatus: componentsGeneratedApi.componentsAPIGetComponentStatus,
    listFeatures: featuresGeneratedApi.featuresAPIListFeatures,
    getComponentByName: componentsGeneratedApi.componentsAPIGetComponentByName,
  };
};
